// Shared helpers of Marketing > Abonamente meniuri.

// Must match MenuSubscription::DAY_NAMES in the API.
export const DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']

// Must match MenuSubscriptionMenuItem::COURSES in the API
// (1-3 = Felul 1-3, 4 = Desert, 5 = Mic dejun, 6 = Prânz, 7 = Cină, 8 = Gustare).
export const COURSES = [1, 2, 3, 4, 5, 6, 7, 8]

// readinessIssues() of the API -> readable text
export function issuesText (vm, issues) {
  return (issues || []).map(issue => {
    if (issue.key === 'menu_price_mismatch') {
      return vm.$t('menuSubscriptions.issues.menu_price_mismatch', { menus: (issue.menus || []).join(', ') })
    }
    return vm.$t('menuSubscriptions.issues.' + issue.key)
  }).join('; ')
}

export function toCents (value) {
  const number = parseFloat(value)
  return isNaN(number) ? 0 : Math.round(number * 100)
}

export function formatMoney (cents) {
  return (cents / 100).toFixed(2)
}

/**
 * New unit prices (strings, 2 decimals) so that sum(price * quantity) is EXACTLY target.
 * Same rule as MenuSubscriptionService::scalePrices in the API: each line keeps its share of
 * the current total (or of the catalog price when every price is 0, or of the quantity),
 * the rounding difference goes to a line with quantity 1, else to a line whose quantity divides it.
 * Returns null when it can't add up exactly (e.g. all quantities are 2 and the target has odd cents).
 *
 * @param {Array} lines [{price, quantity, catalog_price}]
 * @param {Number|String} target
 */
export function scalePrices (lines, target) {
  const targetCents = toCents(target)
  if (!lines.length || targetCents < 0) {
    return null
  }
  const qty = line => Math.max(1, parseInt(line.quantity, 10) || 1)

  let weights = lines.map(line => Math.max(0, toCents(line.price)) * qty(line))
  let weightSum = weights.reduce((a, b) => a + b, 0)
  if (weightSum <= 0) {
    weights = lines.map(line => Math.max(0, toCents(line.catalog_price)) * qty(line))
    weightSum = weights.reduce((a, b) => a + b, 0)
  }
  if (weightSum <= 0) {
    weights = lines.map(line => qty(line))
    weightSum = weights.reduce((a, b) => a + b, 0)
  }

  const units = lines.map((line, i) => Math.max(0, Math.round((targetCents * weights[i] / weightSum) / qty(line))))
  let sum = units.reduce((total, unit, i) => total + unit * qty(lines[i]), 0)
  const diff = targetCents - sum

  if (diff !== 0) {
    const order = lines.map((line, i) => i).sort((a, b) => units[b] * qty(lines[b]) - units[a] * qty(lines[a]))
    let fixed = false
    for (const onlyOne of [true, false]) {
      for (const i of order) {
        const q = qty(lines[i])
        if ((onlyOne && q !== 1) || diff % q !== 0 || units[i] + diff / q < 0) {
          continue
        }
        units[i] += diff / q
        fixed = true
        break
      }
      if (fixed) {
        break
      }
    }
    if (!fixed) {
      return null
    }
  }

  return units.map(formatMoney)
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Marketing/MenuSubscriptions/menuSubscriptionHelpers.js